import { useMemo } from "react";
import { cn, Tooltip } from "ui";
import {
  formatDate,
  formatRelativeDate,
  formatToUtcDate,
} from "../utils/formatDate";

export default function DateDisplay({
  date,
  className,
  format,
  tooltipFormat,
  children,
  showRelativeDate = true,
}: {
  date: Date | string;
  className?: string;
  format?: string;
  tooltipFormat?: string;
  children?: React.ReactNode;
  showRelativeDate?: boolean;
}) {
  const dateObj = useMemo(
    () => (typeof date === "string" ? new Date(date) : date),
    [date]
  );
  return (
    <Tooltip size="sm" content={formatToUtcDate(dateObj, tooltipFormat)}>
      <span
        className={cn(
          "underline decoration-dotted underline-offset-2",
          className
        )}
      >
        {children ? (
          children
        ) : (
          <>
            {formatDate(dateObj, format)}{" "}
            {showRelativeDate && <>({formatRelativeDate(dateObj)})</>}
          </>
        )}
      </span>
    </Tooltip>
  );
}
